import type { VariantHistoricalPricingModel } from "@/features/products/api/useProductHistoricalPricing";
import dayjs from "dayjs";

export interface ProductHistoricalPricingChartRecord {
	date: string;
	[variantId: string]: string | number;
}

export const getProductHistoricalPricingChartData = (historicalPricingResponseModel: VariantHistoricalPricingModel[]): ProductHistoricalPricingChartRecord[] => {
	const dateMap: Record<string, ProductHistoricalPricingChartRecord> = { };

	for (const variant of historicalPricingResponseModel) {
		for (const price of variant.prices) {
			const date = dayjs(price.date).format("DD MMM YYYY");
			if (!dateMap[date]) {
				dateMap[date] = { date };
			}

			dateMap[date][variant.variantId] = price.price.value;
		}
	}

	return Object.values(dateMap).sort((a, b) => dayjs(a.date).diff(dayjs(b.date)));
};
